import { cached } from 'Utility/async';

export enum FarmItemUnlockType {
    CROP = 'crop',
    WORLD = 'world',
    PREMIUM = 'premium',
}

export const CACHED_FARM_ITEM_UNLOCK_TYPE = cached<FarmItemUnlockType[]>(() => {
    return Object.values(FarmItemUnlockType);
});

export function isFarmItemUnlockType(value: unknown): value is FarmItemUnlockType {
    return CACHED_FARM_ITEM_UNLOCK_TYPE().includes(value as FarmItemUnlockType);
}
